import _ from 'lodash';

import {
  ActionNameAndMeta,
  CallApiActionType,
  CallApiActionTypes,
  Dispatch,
} from '../../redux.types';

function getActionNameAndMeta(type: CallApiActionType): ActionNameAndMeta {
  if (typeof type === 'string') {
    return {
      name: type,
      notification: undefined,
    };
  }

  return type;
}

export interface CallApiSuccessResponse<Payload, Data = any> {
  responsePayload: Payload;
  rawResponse: any;
  additionalData: Data;
}

export const callApiMiddleware = ({
  dispatch,
}: {
  dispatch: Dispatch;
  getState?;
}): any => {
  return (next) => (action) => {
    const { types, callApi, additionalData = {} } = action;

    if (!types || !callApi) {
      // Not a 'call-api' action: pass it on
      return next(action);
    }

    if (
      !Array.isArray(types) ||
      types.length !== 3 ||
      !types.every((type) => typeof type === 'string' || _.isObject(type))
    ) {
      throw new Error('Expected an array of three string or object types.');
    }

    if (typeof callApi !== 'function') {
      throw new Error('Expected callApi to be a function.');
    }

    const [requestType, successType, failureType]: ActionNameAndMeta[] = _.map<
      CallApiActionType,
      ActionNameAndMeta
    >(types as CallApiActionTypes, getActionNameAndMeta);

    dispatch(
      _.assign(
        {},
        {
          payload: {
            additionalData,
          },
          type: requestType.name,
          notification: requestType.notification,
        },
      ),
    );

    return callApi().then(
      (response) => {
        dispatch(
          _.assign(
            {},
            {
              payload: {
                responsePayload: _.get(response, 'data.payload'),
                rawResponse: response,
                additionalData,
              },
              type: successType.name,
              notification: successType.notification,
            },
          ),
        );
        return response;
      },
      (res) => {
        const { response } = res;
        dispatch(
          _.assign(
            {},
            {
              payload: {
                additionalData,
                errorCode: _.get(response, 'data.code') | res.code,
                rawResponse: response,
                error: true,
              },
              type: failureType.name,
              notification: failureType.notification,
            },
          ),
        );

        return Promise.reject(response);
      },
    );
  };
};
